<div class="date-filter-container" [ngStyle]="controlStyles">
  <label class="date-filter-label">{{ label }}</label>

  <button
    #menuTrigger="matMenuTrigger"
    type="button"
    class="date-filter-select"
    [class.is-open]="menuTrigger.menuOpen"
    [class.has-value]="selectedDates.length > 0"
    [disabled]="disabled"
    [matMenuTriggerFor]="dateMenu"
    aria-haspopup="dialog"
    [attr.aria-label]="label">
    <span class="date-filter-value">
      @if (selectedDates.length === 0) {
        <span class="date-filter-placeholder">{{ placeholder }}</span>
      } @else {
        @for (date of selectedDates; track date) {
          <span class="date-chip">
            <span class="date-chip-remove" role="button" tabindex="0"
              (click)="removeDate(date, $event)"
              (keydown.enter)="removeDate(date, $event)"
              [attr.aria-label]="'Remove ' + formatDate(date)">×</span>
            <span class="date-chip-label">{{ formatDate(date) }}</span>
          </span>
        }
      }
    </span>

    @if (selectedDates.length > 0 && !disabled) {
      <span class="date-filter-clear" role="button" tabindex="0"
        (click)="clearDates($event)" (keydown.enter)="clearDates($event)"
        aria-label="Clear selected dates">×</span>
    }
    <span class="date-filter-arrow" aria-hidden="true"></span>
  </button>
</div>

<mat-menu #dateMenu="matMenu" class="multi-date-calendar-menu" [overlapTrigger]="false">
  <div class="multi-date-calendar-panel" role="dialog" [attr.aria-label]="label"
    (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
    <mat-calendar
      [selected]="null"
      [dateClass]="dateClass"
      (selectedChange)="toggleDate($event)">
    </mat-calendar>
  </div>
</mat-menu>
